import { getUserRole } from 'applicaiton/sessionStorage/auth';
import { UserRoles } from 'applicaiton/constants/userRoles';
import { userRoleExactMatch } from '../helpers/userRoleExactMatch';

/**
 * Custom hook to check if a user has the correct role.
 *
 * This hook retrieves the user's current role from session storage and checks
 * whether it matches one of the predefined roles (admin, secretary, clinic owner,
 * or professional). If the user's role is not recognized or does not match any
 * of these predefined roles, the hook will return false for correctUserRole.
 *
 * @returns An object with a single property: `correctUserRole`. This property
 *          will be true if the user has one of the four allowed roles (admin,
 *          secretary, clinic owner, professional). Otherwise, it will be false.
 */
export const useCheckUserRole = () => {
  const userRole = getUserRole();
  const isClinicOwner = userRole?.includes(UserRoles.clinicOwner);
  const isProfessional = userRole?.includes(UserRoles.professional);
  const isAdmin = userRoleExactMatch(UserRoles.admin);
  const isSecretary = userRole?.includes(UserRoles.secretary);

  const correctUserRole =
    !userRole ||
    (userRole?.length &&
      (isAdmin || isSecretary || isClinicOwner || isProfessional));

  if (correctUserRole) {
    return { correctUserRole: true };
  } else {
    return { correctUserRole: false };
  }
};
